import React from 'react';
import Reveal from 'react-awesome-reveal';

// Import Custom Component
import ProductCard from '../../features/products/product-card';
import OwlCarousel from '../../features/owl-carousel';

// Import Settings
import {productSlider} from '../../../utils/data/slider';
import {fadeInLeftShorter} from '../../../utils/data/keyframes'
import useTranslation from "../../../utils/hooks/useTranslation";

export default function FeaturedCollection(props) {
    const { t } = useTranslation();
    const {products, loading} = props;
    const sliderOptions = { ...productSlider, dots: true };

    return (
        <section className="featured-products-section">
            <div className="container">
                <div className="section-header">
                    <span className="section-eyebrow">{t('message.handpicked_for_you')}</span>
                    <h2>{t('message.featured_products')}</h2>
                    <p className="section-subtitle">{t('message.featured_products_subtitle')}</p>
                </div>

                <OwlCarousel
                    adClass="products-slider modern-slider owl-theme custom-products"
                    options={sliderOptions}>
                    {
                        loading ?
                            [0, 1, 2, 3, 4].map((item, index) =>
                                <div className="skel-pro skel-pro-grid" key={"products-one" + index}></div>
                            )
                            :
                            products?.map((item) => (
                                <Reveal keyframes={fadeInLeftShorter} delay={100} duration={1000} triggerOnce
                                        key={"featured-products-" + item.id}>
                                    <ProductCard
                                        product={item}
                                    />
                                </Reveal>
                            ) )

                    }
                </OwlCarousel>
            </div>
        </section>
    );
}